import { useEffect, useState } from 'react'
import { useScript } from 'usehooks-ts'
import { gapiContext } from './context'
import { gapiConfig } from './constants'

export function GapiProvider({ children }: { children: React.ReactNode }) {
  const status = useScript('https://apis.google.com/js/api.js', {
    removeOnUnmount: false,
  })
  const [isReady, setIsReady] = useState<boolean>(false)

  useEffect(() => {
    if (status === 'ready') {
      // Initialize gapi unconditionally when script is ready
      // Individual hooks will handle token management and account-specific logic
      gapi.load('client', () => {
        void gapi.client.init(gapiConfig).then(() => {
          // eslint-disable-next-line no-console
          console.log('gapi client loaded')
          setIsReady(true)
        })
      })
    }
  }, [status])

  return <gapiContext.Provider value={isReady}>{children}</gapiContext.Provider>
}
